import { isUsdStableAddress } from '@/utils/multichain';
import { tokenKey } from '@/utils/normalizeAddress';

export type ChartTokenIdentity = { address: string; chainId: number };

export const isSameChartToken = (
  a: ChartTokenIdentity | undefined,
  b: ChartTokenIdentity | undefined,
): boolean => !!a && !!b && tokenKey(a.address, a.chainId) === tokenKey(b.address, b.chainId);

/**
 * Charted token for the current pair: the previous pick while it is still in
 * the pair, otherwise the buy token unless it is a USD stablecoin, whose flat
 * series says nothing. Returns undefined until both sides of the pair are
 * known, so the default is not committed against a half-resolved pair.
 */
export const resolveChartToken = (
  selected: ChartTokenIdentity | undefined,
  sellToken: ChartTokenIdentity | undefined,
  buyToken: ChartTokenIdentity | undefined,
): ChartTokenIdentity | undefined => {
  if (!sellToken || !buyToken) return undefined;

  if (selected && (isSameChartToken(selected, sellToken) || isSameChartToken(selected, buyToken))) {
    return selected;
  }

  return isUsdStableAddress(buyToken.address, buyToken.chainId) ? sellToken : buyToken;
};
